import React, { Suspense, lazy } from 'react';
import { Routes, Route,Navigate} from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import withNavigate from "app/hooks/withNavigate";
import withAppContext from "app/hooks/withAppContext";
import StageContext from "app/context/StageContext";
import SnackbarMessageContent  from "./SnackbarMessageContent";
import {HOME_LOGIN_SCREEN_STATUS,
  ADMIN_SCREEN_STATUS,
  MERCHANT_CRUD_SCREEN_STATUS,
  MERCHANT_PRODUCT_CRUD_SCREEN_STATUS,
  ECOSYSTEM_DEVICE_CRUD_SCREEN_STATUS,
  SERVICE_TABLE_CRUD_SCREEN_STATUS,
  SERVICE_SEQUENCE_CRUD_SCREEN_STATUS,
  CHECKIN_PROJECT_CRUD_SCREEN_STATUS,
  CHECKIN_ZONE_CRUD_SCREEN_STATUS,
  GATEWAY_PASSAGE_CRUD_SCREEN_STATUS,
  ASSIGN_POS_SCREEN_STATUS,
  REASSIGN_POS_SCREEN_STATUS,
  ASSIGN_DEPOSIT_SCREEN_STATUS,
  REASSIGN_DEPOSIT_SCREEN_STATUS,
  ASSIGN_STAFF_NAME_SCREEN_STATUS,
  ASSIGNED_LIST_USER_SCREEN_STATUS,
  ASSIGN_POS_ECOSYSTEM_SCREEN_STATUS,
  REASSIGN_POS_ECOSYSTEM_SCREEN_STATUS,
  ASSIGN_DEPOSIT_ECOSYSTEM_SCREEN_STATUS,
  REASSIGN_DEPOSIT_ECOSYSTEM_SCREEN_STATUS,
  ASSIGN_GATEWAY_ECOSYSTEM_SCREEN_STATUS,
  REASSIGN_GATEWAY_ECOSYSTEM_SCREEN_STATUS,
  ASSIGN_SUPERVISOR_ECOSYSTEM_SCREEN_STATUS,
  REASSIGN_SUPERVISOR_ECOSYSTEM_SCREEN_STATUS,
  ASSIGN_BRAND_ACTIVATION_ECOSYSTEM_SCREEN_STATUS,
  REASSIGN_BRAND_ACTIVATION_ECOSYSTEM_SCREEN_STATUS,
  ASSIGN_SERVICE_ORDER_ECOSYSTEM_SCREEN_STATUS,
  REASSIGN_SERVICE_ORDER_ECOSYSTEM_SCREEN_STATUS,
  //ASSIGN_STAFF_NAME_ECOSYSTEM_SCREEN_STATUS,
  //ASSIGNED_LIST_USER_ECOSYSTEM_SCREEN_STATUS,  
  CLIENT_ACCOUNT_BALANCE_REPORT_SCREEN,
  DEPOSIT_SUMMARY_REPORT_SCREEN,
  DEPOSIT_SUMMARY_CUTOFF_REPORT_SCREEN,
  GATEWAY_SUMMARY_REPORT_SCREEN,
  GATEWAY_SUMMARY_CUTOFF_REPORT_SCREEN,
  MERCHANT_SUMMARY_REPORT_SCREEN,
  MERCHANT_SUMMARY_CUTOFF_REPORT_SCREEN,
  STAFF_CUTOFF_REPORT_SCREEN,
  CREATE_CLIENT_ACCOUNT,
  CREATE_ENROLLED_CLIENT_ACCOUNT,
  ACTIVATE_CLIENT_ACCOUNT,
  ACTIVATE_ENROLLED_CLIENT_ACCOUNT,
  ACTIVATE_ENROLLED_CLIENT_ACCOUNT_NAME,
  ACTIVATE_ENROLLED_CLIENT_ACCOUNT_QR,
  CREATE_STAFF_USER,
  CONVENTION_CRUD_SCREEN_STATUS,
  CONFERENCE_CRUD_SCREEN_STATUS,
  EXPOSITOR_CRUD_SCREEN_STATUS,
  CONFERENCE_GUEST_CRUD_SCREEN_STATUS,
  
  CLIENT_ACCOUNT_UPLOAD_SCREEN,  
  ENROLLED_CLIENT_ACCOUNT_UPLOAD_SCREEN,  
  CONFERENCE_GUEST_UPLOAD_SCREEN,
  SUBSYSTEM_REBOOT_SCREEN
} from "app/constants/AppConstants";
import StageModuleLogic from "./StageModuleLogic";
import CatalogModuleLogic from "./catalogs/CatalogModuleLogic";
import SetupModuleLogic from "./setup/SetupModuleLogic";
import ReportsModuleLogic from "./reports/ReportsModuleLogic";
import AssignmentModuleLogic from './assignment/AssignmentModuleLogic';
import RegistryModuleLogic from './registry/RegistryModuleLogic';
import ConventionModuleLogic from './conventions/ConventionModuleLogic';


const LoginScreen = lazy(() => import('./home/LoginScreen'));
const AdminScreen = lazy(() => import('./admin/AdminScreen'));

/*Catalogs*/
const MerchantCrudScreen = lazy(() => import('./catalogs/MerchantCrudScreen'));
const MerchantProductCrudScreen = lazy(() => import('./catalogs/MerchantProductCrudScreen'));
const EcosystemDeviceCrudScreen = lazy(() => import('./catalogs/EcosystemDeviceCrudScreen'));
const ServiceTableCrudScreen = lazy(() => import('./catalogs/ServiceTableCrudScreen'));
const ServiceSequenceCrudScreen = lazy(() => import('./catalogs/ServiceSequenceCrudScreen'));
const CheckinProjectCrudScreen = lazy(() => import('./catalogs/CheckinProjectCrudScreen'));
const CheckinZoneCrudScreen = lazy(() => import('./catalogs/CheckinZoneCrudScreen'));
const GatewayPassageCrudScreen = lazy(() => import('./catalogs/GatewayPassageCrudScreen'));

/*Assignment Devices*/
const AssignPosScreen = lazy(() => import('./assignment/AssignPosScreen'));
const ReassignPosScreen = lazy(() => import('./assignment/ReassignPosScreen'));
const AssignDepositScreen = lazy(() => import('./assignment/AssignDepositScreen'));
const ReassignDepositScreen = lazy(() => import('./assignment/ReassignDepositScreen'));
const AssignStaffNameScreen = lazy(() => import('./assignment/AssignStaffNameScreen'));

/*Assignment Ecosystem Devices*/
const AssignPosEcosystemScreen = lazy(() => import('./assignment/AssignPosEcosystemScreen'));
const ReassignPosEcosystemScreen = lazy(() => import('./assignment/ReassignPosEcosystemScreen'));
const AssignDepositEcosystemScreen = lazy(() => import('./assignment/AssignDepositEcosystemScreen'));
const ReassignDepositEcosystemScreen = lazy(() => import('./assignment/ReassignDepositEcosystemScreen'));
const AssignGatewayEcosystemScreen = lazy(() => import('./assignment/AssignGatewayEcosystemScreen'));
const ReassignGatewayEcosystemScreen = lazy(() => import('./assignment/ReassignGatewayEcosystemScreen'));
const AssignSupervisorEcosystemScreen = lazy(() => import('./assignment/AssignSupervisorEcosystemScreen'));
const ReassignSupervisorEcosystemScreen = lazy(() => import('./assignment/ReassignSupervisorEcosystemScreen'));
const AssignBrandActivationEcosystemScreen = lazy(() => import('./assignment/AssignBrandActivationEcosystemScreen'));
const ReassignBrandActivationEcosystemScreen = lazy(() => import('./assignment/ReassignBrandActivationEcosystemScreen'));
const AssignServiceOrderEcosystemScreen = lazy(() => import('./assignment/AssignServiceOrderEcosystemScreen'));
const ReassignServiceOrderEcosystemScreen = lazy(() => import('./assignment/ReassignServiceOrderEcosystemScreen'));
//const AssignStaffNameEcosystemScreen = lazy(() => import('./assignment/AssignStaffNameEcosystemScreen'));
//const AssignedListUserEcosystemScreen = lazy(() => import('./assignment/AssignedListUserEcosystemScreen'));

/*Reports*/
const ClientAccountBalanceReportScreen = lazy(() => import('./reports/ClientAccountBalanceReportScreen'));
const DepositSummaryReportScreen = lazy(() => import('./reports/DepositSummaryReportScreen'));
const DepositSummaryCutoffReportScreen = lazy(() => import('./reports/DepositSummaryCutoffReportScreen'));
const GatewaySummaryReportScreen = lazy(() => import('./reports/GatewaySummaryReportScreen'));
const GatewaySummaryCutoffReportScreen = lazy(() => import('./reports/GatewaySummaryCutoffReportScreen')); 
const MerchantSummaryReportScreen = lazy(() => import('./reports/MerchantSummaryReportScreen'));
const MerchantSummaryCutoffReportScreen = lazy(() => import('./reports/MerchantSummaryCutoffReportScreen'));
const ProductSummaryReportScreen = lazy(() => import('./reports/ProductSummaryReportScreen'));
const ProductSummaryCutoffReportScreen = lazy(() => import('./reports/ProductSummaryCutoffReportScreen'));
const StaffCutoffReportScreen = lazy(() => import('./reports/StaffCutoffReportScreen'));
const AssignedListUserScreen = lazy(() => import('./assignment/AssignedListUserScreen'));

/*Registry*/
const CreateClientAccountScreen = lazy(() => import('./registry/CreateClientAccountScreen'));
const CreateEnrolledClientAccountScreen = lazy(() => import('./registry/CreateEnrolledClientAccountScreen'));
const ActivateClientAccountScreen = lazy(() => import('./registry/ActivateClientAccountScreen'));
const ActivateEnrolledClientAccountScreen = lazy(() => import('./registry/ActivateEnrolledClientAccountScreen'));
const ActivateEnrolledClientAccountNameScreen = lazy(() => import('./registry/ActivateEnrolledClientAccountNameScreen'));
const ActivateEnrolledClientAccountQRScreen = lazy(() => import('./registry/ActivateEnrolledClientAccountQRScreen'));
const CreateStaffUserScreen = lazy(() => import('./registry/CreateStaffUserScreen'));

/*Conventions*/
const ConventionCrudScreen = lazy(() => import('./conventions/ConventionCrudScreen'));
const ConferenceCrudScreen = lazy(() => import('./conventions/ConferenceCrudScreen'));
const ExpositorCrudScreen = lazy(() => import('./conventions/ExpositorCrudScreen'));
const ConferenceGuestCrudScreen = lazy(() => import('./conventions/ConferenceGuestCrudScreen'));

/*setup*/
const ClientAccountUploadScreen = lazy(() => import('./setup/clientAccount/ClientAccountUploadScreen'));
const EnrolledClientAccountUploadScreen = lazy(() => import('./setup/clientAccount/EnrolledClientAccountUploadScreen'));
const ConferenceGuestUploadScreen = lazy(() => import('./setup/clientAccount/ConferenceGuestUploadScreen'));
const SubsystemRebootScreen = lazy(() => import('./setup/SubsystemRebootScreen'));


class Stage extends React.Component {
  appContext;
  framework;
  navigate;
  history;
  stageModuleLogic;
  catalogModuleLogic;
  setupModuleLogic;
  reportsModuleLogic;
  registryModuleLogic;
  conventionModuleLogic;

  state = {
    activeScreen:HOME_LOGIN_SCREEN_STATUS,
    snackbarOpenFlag: false,
    snackbarMessage : "",
    snackbarMessageType: "error",    
  };

  constructor(props) {
    super(props);
    this.appContext = props.appContext;
    this.framework = props.appContext.framework;
    this.history = props.history;
    this.stageModuleLogic = new StageModuleLogic(this,this.appContext,this.framework);
    this.catalogModuleLogic = new CatalogModuleLogic(this,this.appContext,this.framework);
    this.setupModuleLogic = new SetupModuleLogic(this,this.appContext,this.framework);
    this.reportsModuleLogic = new ReportsModuleLogic(this,this.appContext,this.framework);
    this.assignmentModuleLogic = new AssignmentModuleLogic(this,this.appContext,this.framework);
    this.registryModuleLogic = new RegistryModuleLogic(this,this.appContext,this.framework);
    this.conventionModuleLogic = new ConventionModuleLogic(this,this.appContext,this.framework);
  }


  getNexusUrl() {
    return this.framework.getMemorySystem().getNexusUrl();
  }

  getAppContext() {
    return this.appContext;
  }

  getFramework() {
    return this.framework;
  }

  getStageModuleLogic() {
    return this.stageModuleLogic;
  }

  getCatalogModuleLogic() {
    return this.catalogModuleLogic;
  }

  getSetupModuleLogic() {
    return this.setupModuleLogic;
  }  
  
  getReportsModuleLogic() {
    return this.reportsModuleLogic;
  }  

  getAssignmentModuleLogic(){
    return this.assignmentModuleLogic;
  }

  getRegistryModuleLogic(){
    return this.registryModuleLogic;
  }  

  getConventionModuleLogic(){
    return this.conventionModuleLogic;
  }  

  getActiveScreen() {
    return this.state.activeScreen;
  }

  switchActiveScreen(activeScreen) {
    if(HOME_LOGIN_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/login");
    } 
    else if(ADMIN_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/admin");
    }
    else if(MERCHANT_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/merchantCrud");
    }    
    else if(MERCHANT_PRODUCT_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/merchantProductCrud");
    }    
    else if(ECOSYSTEM_DEVICE_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/ecosystemDeviceCrud");
    }    
    else if(SERVICE_TABLE_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/serviceTableCrud");
    }            
    else if(SERVICE_SEQUENCE_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/serviceSequenceCrud");
    }    
    else if(CHECKIN_PROJECT_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/checkinProjectCrud");
    }    
    else if(CHECKIN_ZONE_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/checkinZoneCrud");
    }    
    else if(GATEWAY_PASSAGE_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/gatewayPassageCrud");
    }        
    else if(ASSIGN_POS_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignPos");
    }        
    else if(REASSIGN_POS_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/reassignPos");
    }        
    else if(ASSIGN_DEPOSIT_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignDeposit");
    }        
    else if(REASSIGN_DEPOSIT_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/reassignDeposit");
    }            
    else if(ASSIGN_STAFF_NAME_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignStaffName");
    }            
    else if(ASSIGNED_LIST_USER_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignedListUser");
    }   
    /*Ecosystem*/
    else if(ASSIGN_POS_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignPosEcosystem");
    }        
    else if(REASSIGN_POS_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/reassignPosEcosystem");
    }        
    else if(ASSIGN_DEPOSIT_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignDepositEcosystem");
    }        
    else if(REASSIGN_DEPOSIT_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/reassignDepositEcosystem");
    }            
    else if(ASSIGN_GATEWAY_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignGatewayEcosystem");
    }        
    else if(REASSIGN_GATEWAY_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/reassignGatewayEcosystem");
    }                
    else if(ASSIGN_SUPERVISOR_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignSupervisorEcosystem");
    }        
    else if(REASSIGN_SUPERVISOR_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/reassignSupervisorEcosystem");
    }                
    else if(ASSIGN_BRAND_ACTIVATION_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignBrandActivationEcosystem");
    }        
    else if(REASSIGN_BRAND_ACTIVATION_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/reassignBrandActivationEcosystem");
    }                    
    else if(ASSIGN_SERVICE_ORDER_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignServiceOrderEcosystem");
    }        
    else if(REASSIGN_SERVICE_ORDER_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/reassignServiceOrderEcosystem");
    }                    

    /*else if(ASSIGN_STAFF_NAME_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignStaffNameEcosystem");
    }            
    else if(ASSIGNED_LIST_USER_ECOSYSTEM_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/assignedListUserEcosystem");
    } */ 

    else if(CLIENT_ACCOUNT_BALANCE_REPORT_SCREEN === activeScreen) {
      this.props.navigate("/clientAccountBalanceReport");
    }
    else if(DEPOSIT_SUMMARY_REPORT_SCREEN === activeScreen) {
      this.props.navigate("/depositSummaryReport");
    }
    else if(DEPOSIT_SUMMARY_CUTOFF_REPORT_SCREEN === activeScreen) {
      this.props.navigate("/depositSummaryCutoffReport");
    }        
    else if(GATEWAY_SUMMARY_REPORT_SCREEN === activeScreen) {
      this.props.navigate("/gatewaySummaryReport");
    }        
    else if(GATEWAY_SUMMARY_CUTOFF_REPORT_SCREEN === activeScreen) {
      this.props.navigate("/gatewaySummaryCutoffReport");
    }        
    else if(MERCHANT_SUMMARY_REPORT_SCREEN === activeScreen) {
      this.props.navigate("/merchantSummaryReport");
    }
    else if(MERCHANT_SUMMARY_CUTOFF_REPORT_SCREEN === activeScreen) {
      this.props.navigate("/merchantSummaryCutoffReport");
    }   
    else if(STAFF_CUTOFF_REPORT_SCREEN === activeScreen) {
      this.props.navigate("/staffCutoffReport");
    }     
    else if(CREATE_CLIENT_ACCOUNT === activeScreen) {
      this.props.navigate("/createClientAccountScreen");
    }                 
    else if(CREATE_ENROLLED_CLIENT_ACCOUNT === activeScreen) {
      this.props.navigate("/createEnrolledClientAccountScreen");
    }                 
    else if(ACTIVATE_CLIENT_ACCOUNT === activeScreen) {
      this.props.navigate("/activateClientAccountScreen");
    }                 
    else if(ACTIVATE_ENROLLED_CLIENT_ACCOUNT === activeScreen) {
      this.props.navigate("/activateEnrolledClientAccountScreen");
    }                 
    else if(ACTIVATE_ENROLLED_CLIENT_ACCOUNT_NAME === activeScreen) {
      this.props.navigate("/activateEnrolledClientAccountNameScreen");
    }                     
    else if(ACTIVATE_ENROLLED_CLIENT_ACCOUNT_QR === activeScreen) {
      this.props.navigate("/activateEnrolledClientAccountQRScreen");
    }  
    else if(CREATE_STAFF_USER === activeScreen) {
      this.props.navigate("/createStaffUserScreen");
    }    
    else if(CONVENTION_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/conventionCrud");
    }      
    else if(CONFERENCE_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/conferenceCrud");
    }    
    else if(EXPOSITOR_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/expositorCrud");
    }    
    else if(CONFERENCE_GUEST_CRUD_SCREEN_STATUS === activeScreen) {
      this.props.navigate("/conferenceGuestCrud");
    }    
    else if(CLIENT_ACCOUNT_UPLOAD_SCREEN === activeScreen) {
      this.props.navigate("/clientAccountUploadScreen");
    }             
    else if(ENROLLED_CLIENT_ACCOUNT_UPLOAD_SCREEN === activeScreen) {
      this.props.navigate("/enrolledClientAccountUploadScreen");
    }      
    else if(CONFERENCE_GUEST_UPLOAD_SCREEN === activeScreen) {
      this.props.navigate("/conferenceGuestUploadScreen");
    }                        
    else if(SUBSYSTEM_REBOOT_SCREEN === activeScreen) {
      this.props.navigate("/subsystemRebootScreen");
    }                            
  }  

  log(appError) {
    let processedMessage = "---";
    if(appError !== undefined && appError !== null) {
      console.log(appError);    
      console.log("developerMessage:" + appError.developerMessage);
      console.log("exceptionType:" + appError.exceptionType);    
      processedMessage = "["+ appError.code+"]" + appError.userMessage;
      console.log(processedMessage);    
    }
    else {
      console.log("app error is undefined");    
    }
  }  

  showToastMessage(message,messageCode) {
    let processedMessage = "---";
    if(messageCode !== undefined && messageCode !== null) {
      processedMessage = "["+ messageCode+"]" + message;
    }
    else {
      processedMessage = message;
    }
    this.setState({snackbarOpenFlag: true, snackbarMessageType: "info", snackbarMessage: processedMessage});
  }  

  showToastError(error,userMessage,errorCode,exceptionType) {
    let appError = this.framework.getErrorSystem().getAppError(error,userMessage,errorCode,exceptionType);
    this.showToastAppError(appError,appError.code);
  }

  showToastAppError(appError,appErrorCode) {
    let processedMessage = "---";
    if(appErrorCode !== undefined && appErrorCode !== null) {
      console.log(appErrorCode);
      console.log(appError.developerMessage);
      console.log(appError.exceptionType);    
      processedMessage = "["+ appErrorCode+"]" + appError.userMessage;
    }
    else {
      processedMessage = "["+ appError.code+"]" + appError.userMessage;
    }
    this.setState({snackbarOpenFlag: true, snackbarMessageType: "error", snackbarMessage: processedMessage});
  }

  showMessageDialog(messageCode,message) {
    
  }  

  showErrorDialog(appErrorCode,appError) {
    
  } 

  handleCloseSnackbar(){
    this.setState({snackbarOpenFlag: false});
  }   

  render() {    
    return (
      <div>
      <StageContext.Provider value={this}>        
          <Suspense fallback={<LoadingPane />}>
            <Routes>              
              <Route path="/login" element={<LoginScreen />}/>
              <Route path="/admin" element={<AdminScreen />}/>
              <Route path="/merchantCrud" element={<MerchantCrudScreen />}/>
              <Route path="/merchantProductCrud" element={<MerchantProductCrudScreen />}/>
              <Route path="/ecosystemDeviceCrud" element={<EcosystemDeviceCrudScreen />}/>
              <Route path="/serviceTableCrud" element={<ServiceTableCrudScreen />}/>
              <Route path="/serviceSequenceCrud" element={<ServiceSequenceCrudScreen />}/>
              <Route path="/checkinProjectCrud" element={<CheckinProjectCrudScreen />}/>
              <Route path="/checkinZoneCrud" element={<CheckinZoneCrudScreen />}/>
              <Route path="/gatewayPassageCrud" element={<GatewayPassageCrudScreen />}/>
              <Route path="/assignPos" element={<AssignPosScreen/>}/>
              <Route path="/reassignPos" element={<ReassignPosScreen />}/>
              <Route path="/assignDeposit" element={<AssignDepositScreen />}/>
              <Route path="/reassignDeposit" element={<ReassignDepositScreen />}/>
              <Route path="/assignStaffName" element={<AssignStaffNameScreen />}/>
              <Route path="/assignedListUser" element={<AssignedListUserScreen />}/>
              <Route path="/assignPosEcosystem" element={<AssignPosEcosystemScreen/>}/>
              <Route path="/reassignPosEcosystem" element={<ReassignPosEcosystemScreen />}/>
              <Route path="/assignDepositEcosystem" element={<AssignDepositEcosystemScreen />}/>
              <Route path="/reassignDepositEcosystem" element={<ReassignDepositEcosystemScreen />}/>
              <Route path="/assignGatewayEcosystem" element={<AssignGatewayEcosystemScreen />}/>
              <Route path="/reassignGatewayEcosystem" element={<ReassignGatewayEcosystemScreen />}/>
              <Route path="/assignSupervisorEcosystem" element={<AssignSupervisorEcosystemScreen />}/>
              <Route path="/reassignSupervisorEcosystem" element={<ReassignSupervisorEcosystemScreen />}/>
              <Route path="/assignBrandActivationEcosystem" element={<AssignBrandActivationEcosystemScreen />}/>
              <Route path="/reassignBrandActivationEcosystem" element={<ReassignBrandActivationEcosystemScreen />}/>
              <Route path="/assignServiceOrderEcosystem" element={<AssignServiceOrderEcosystemScreen />}/>
              <Route path="/reassignServiceOrderEcosystem" element={<ReassignServiceOrderEcosystemScreen />}/>
              {/*<Route path="/assignStaffNameEcosystem" element={<AssignStaffNameEcosystemScreen />}/>
              <Route path="/assignedListUserEcosystem" element={<AssignedListUserEcosystemScreen />}/>*/}
              <Route path="/clientAccountBalanceReport" element={<ClientAccountBalanceReportScreen />}/>
              <Route path="/depositSummaryReport" element={<DepositSummaryReportScreen/>}/>
              <Route path="/depositSummaryCutoffReport" element={<DepositSummaryCutoffReportScreen/>}/>
              <Route path="/gatewaySummaryReport" element={<GatewaySummaryReportScreen/>}/>
              <Route path="/gatewaySummaryCutoffReport" element={<GatewaySummaryCutoffReportScreen/>}/>
              <Route path="/merchantSummaryReport" element={<MerchantSummaryReportScreen/>}/>
              <Route path="/merchantSummaryCutoffReport" element={<MerchantSummaryCutoffReportScreen/>}/>
              <Route path="/productSummaryReport" element={<ProductSummaryReportScreen/>}/>
              <Route path="/productSummaryCutoffReport" element={<ProductSummaryCutoffReportScreen/>}/>
              <Route path="/staffCutoffReport" element={<StaffCutoffReportScreen />}/>
              <Route path="/createClientAccountScreen" element={<CreateClientAccountScreen/>}/>
              <Route path="/createEnrolledClientAccountScreen" element={<CreateEnrolledClientAccountScreen/>}/>
              <Route path="/activateClientAccountScreen" element={<ActivateClientAccountScreen/>}/>
              <Route path="/activateEnrolledClientAccountScreen" element={<ActivateEnrolledClientAccountScreen/>}/>
              <Route path="/activateEnrolledClientAccountNameScreen" element={<ActivateEnrolledClientAccountNameScreen/>}/>
              <Route path="/ActivateEnrolledClientAccountQRScreen" element={<ActivateEnrolledClientAccountQRScreen/>}/> 
              <Route path="/createStaffUserScreen" element={<CreateStaffUserScreen/>}/>   
              <Route path="/conventionCrud" element={<ConventionCrudScreen/>}/>
              <Route path="/conferenceCrud" element={<ConferenceCrudScreen/>}/>
              <Route path="/expositorCrud" element={<ExpositorCrudScreen/>}/>                        
              <Route path="/conferenceGuestCrud" element={<ConferenceGuestCrudScreen/>}/>                        
              <Route path="/clientAccountUploadScreen" element={<ClientAccountUploadScreen/>}/>
              <Route path="/enrolledClientAccountUploadScreen" element={<EnrolledClientAccountUploadScreen/>}/>
              <Route path="/conferenceGuestUploadScreen" element={<ConferenceGuestUploadScreen/>}/>
              <Route path="/subsystemRebootScreen" element={<SubsystemRebootScreen/>}/>              
              <Route path="/" element={<Navigate replace to="/login" />} />
            </Routes>
          </Suspense>
          <Snackbar
            //style={{position:"absolute"}}
            
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={this.state.snackbarOpenFlag}
            autoHideDuration={30000}
            onClose={() => this.handleCloseSnackbar()}
          >
          <SnackbarMessageContent 
            onSnackbarClose={() => this.handleCloseSnackbar()}
            messageType={this.state.snackbarMessageType}
            message={this.state.snackbarMessage}
          />
        </Snackbar>                          
      </StageContext.Provider>                      
      </div>
    );                
  }
}

class LoadingPane extends React.Component {

  getContent() {
    return <CircularProgress style={{'color': 'lightGrey'}} />;
  }

  render() {
    return (
      <div className="theme-light" data-gradient="gradient-1">
      <div id="page">
      <div className="page-content" style={{ margin: "0 auto",width: "500px"}}>
            <div className="page-content">                        
                <div className="card bg-transparent mb-0" style={{height:"100vh",paddingTop:"35px"}}>
                  <div className="card-center mx-3 text-center">                                                
                    {this.getContent()}                                                
                  </div>                    
                </div>
            </div>
            <div className="page-bg"><div></div></div>
        </div> 
      </div> 
    </div>       
    );
  }
}



export default withNavigate(withAppContext(Stage));
